var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13380",
    "data-name": "Group 13380",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.397,
    height: 21.884,
    viewBox: "0 0 16.397 21.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5201",
    "data-name": "Rectangle 5201",
    width: 16.397,
    height: 21.884,
    fill: "#111"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13379",
    "data-name": "Group 13379",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45529",
    "data-name": "Path 45529",
    d: "M8.839.023a5.6,5.6,0,0,1,4.58,3.766c.446,1.405.165,2.975.244,4.431H14.71A2.154,2.154,0,0,1,16.4,9.992l0,10.077a2.065,2.065,0,0,1-1.774,1.813l-12.767,0A2.048,2.048,0,0,1,0,20.069L.006,9.954A2.159,2.159,0,0,1,1.688,8.22H2.734c.079-1.456-.2-3.026.244-4.431A5.607,5.607,0,0,1,7.558.023a9.006,9.006,0,0,1,1.281,0m2.989,8.2V5.168c0-1.841-2.016-3.383-3.78-3.311A3.735,3.735,0,0,0,4.57,5.168V8.22ZM7.89,11.9A1.819,1.819,0,0,0,7.3,15.25c.057.676-.052,1.418.006,2.086a.9.9,0,0,0,1.8,0c.057-.668-.052-1.41.006-2.086A1.811,1.811,0,0,0,7.89,11.9",
    transform: "translate(0 0)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.bdba3de5b6c329cc1ed875cdd94ba8fe.svg";
export { ForwardRef as ReactComponent };